/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import {
  CampaignTypeTriggerInfo,
  campaignTypeTriggerInfo,
  CampaignTypeTriggerName,
} from 'cio/utils/campaigns/campaign-type-trigger-info';

interface TriggerInfoArgs {
  selectedPreviewType: CampaignTypeTriggerName;
  onTriggerConfiguration: () => void;
  toggleHelpModal: () => void;
}

export default class TriggerInfo extends Component<TriggerInfoArgs> {
  questionToAmiImage = new URL('cio/assets/images/question-to-ami.svg', import.meta.url).toString();

  get selectedPreviewType(): CampaignTypeTriggerInfo {
    return campaignTypeTriggerInfo[this.args.selectedPreviewType];
  }
}
